import { InformationPopup } from "./ConfirmationPopup";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const LiteVersionPopup = () => {
    return(
        <InformationPopup
            title={
                <div style={{marginBottom: '10px', display: 'flex', alignItems: 'center'}}>
                    <LockOutlinedIcon style={{ fontSize: '1.5rem', color: '#ff9800' }} />
                    <span style={{ marginLeft: '10px' }}>Versión Lite</span>
                </div>
            }
            message={
                <div style={{marginBottom: '20px'}}>
                    <p style={{ lineHeight: '1.6', color: '#333' }}>
                        Actualmente tienes contratada la version <b style={{ fontWeight: '600' }}>Lite de Qontact.</b>
                    </p>
                    <br />
                    <p style={{ lineHeight: '1.6', color: '#333' }}>
                        Si quieres obtener la <b style={{ fontWeight: '600' }}>version completa de Qontact</b> por favor entra en contacto con nuestro equipo de soporte para gestionar el cambio!
                    </p>
                </div>
            }
            onOK={() => window.open('https://wa.me/+5491155930422?text=Tengo%20la%20version%20Lite%20de%20Qontact%2C%20y%20me%20gustaria%20hablar%20con%20soporte%20para%20mejorar%20mi%20plan%21', '_blank')}
            confirmButtonText="Contactar"
            cancelButtonText="Salir"
        />
    )
}


const UserLimitReachedPopup = () => {
    return(
        <InformationPopup
            title={
                <div style={{marginBottom: '10px', display: 'flex', alignItems: 'center'}}>
                    <LockOutlinedIcon style={{ fontSize: '1.5rem', color: '#ff9800' }} />
                    <span style={{ marginLeft: '10px' }}>{"Alcanzaste el limite de usuarios!".localized()}</span>
                </div>
            }
            message={
                <div style={{marginBottom: '20px'}}>
                    <p style={{ lineHeight: '1.6', color: '#333' }}>
                        {"Para crear o reactivar mas usuarios, deberas ampliar tu plan actual.".localized()}
                    </p>
                    <br />
                    <p style={{ lineHeight: '1.6', color: '#333' }}>
                        {"Entra en contacto con nuestro equipo de soporte para contratar un pack de usuarios adicionales.".localized()}
                    </p>
                </div>
            }
            onOK={() => window.open('https://wa.me/+5491155930422?text=Quiero%20contratar%20un%20pack%20por%20usuarios%20adicionales', '_blank')}
            confirmButtonText="Contactar"
            cancelButtonText="Salir"
        />
    )
}

export { LiteVersionPopup, UserLimitReachedPopup };